module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAABUElEQVQ4jaXUMUscQRQA4E8NREHE9rCxNV1IIRg7wbSnlVZ2If8hRSyCWJxlihRCKsEmHoEEEoKQKop2FjYXEJsgWlmYxqAMvG2Gvd3l7sHC7uzsN+/NPHak1XmQxTgW8Av/85dN4knJnF20sIS3g6Cj2fMEnmEZq4OABfoSRzjFCWbj+T0O8TsWmcSnWLgyUvlrmM8mvcAFnmMaX9COhT9HFf+qMh0rGb/HVYApnqKLHr4G3DfjfE9TnOENXmXjBfynDs7RGyxGB3Qj4xw+qINz9Bq3cZ/KvytJpBbO0TlsxkF9wFRZeXVw2Z6+i1N+3QeshRP6t+bjJvA5vgU8ltAOfgwJr+MjZtI1Gk3cHgJOvbuFfezhstjTQeFe9PMOjrEtO6gC/j4MmKMFvNIA7guWoU3gSrAfWgXXglVoGdwIrEMLOB3eRvzMU0/+rALhEaecXyzyW8m3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tag.png
// module id = MKj7
// module chunks = 1